<script setup lang="ts">
// Wraps an assistant message's MarkdownRender and provides its citation list to
// descendants. CitationChip (the `reference`-node override, registered globally
// in each app's main.ts) injects it, so [n] chips inside this message resolve
// against THIS message's sources. The provide/inject config-provider pattern
// reaches slotted descendants - including the components markstream mounts deep
// in its tree.
import { computed, provide } from 'vue';
import type { ToolStep } from '../types';
import { CITATION_KEY, citationsFromTools } from '../lib/citations';

const props = defineProps<{ tools?: ToolStep[] | undefined }>();

provide(CITATION_KEY, computed(() => citationsFromTools(props.tools)));
</script>

<template>
  <slot />
</template>
